var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.67302 1.5V3.24979M11.8395 1.5V3.24979M0.75586 13.751V5.00042C0.755749 4.77056 0.800928 4.54294 0.888814 4.33055C0.9767 4.11815 1.10557 3.92516 1.26807 3.76259C1.43056 3.60002 1.62349 3.47105 1.83584 3.38307C2.04819 3.29508 2.27579 3.24979 2.50565 3.24979H13.0061C13.4701 3.24979 13.9152 3.43414 14.2434 3.76229C14.5715 4.09044 14.7559 4.53551 14.7559 4.99958V13.751M0.75586 13.751C0.75586 14.2151 0.940212 14.6602 1.26836 14.9883C1.59651 15.3165 2.04158 15.5008 2.50565 15.5008H13.0061C13.4701 15.5008 13.9152 15.3165 14.2434 14.9883C14.5715 14.6602 14.7559 14.2151 14.7559 13.751M0.75586 13.751V7.91674C0.75586 7.45266 0.940212 7.0076 1.26836 6.67945C1.59651 6.3513 2.04158 6.16695 2.50565 6.16695H13.0061C13.4701 6.16695 13.9152 6.3513 14.2434 6.67945C14.5715 7.0076 14.7559 7.45266 14.7559 7.91674V13.751",
    stroke: "#0A1E5B",
    strokeWidth: 1.25703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.aa85924321d888e72b441c80719079ff.svg";
export { ForwardRef as ReactComponent };